<template>
  <v-navigation-drawer v-if="getShowFilterButton" right app v-model="drawer" temporary>
    <v-list dense>
      <filter-component/>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import FilterComponent from "@/components/FilterComponent";
export default {
  name: "app-right-side-drawer",
  props: {
    expanded: {
      type: Boolean,
      default: true
    }
  },
  components: { FilterComponent },
  computed: {
    ...mapGetters("app", ["getShowFilterButton"])
  },
  data: () => ({
    mini: false,
    drawer: false
  }),
  created() {
    window.getApp.$on("APP_RIGHT_DRAWER_TOGGLE", () => {
      this.drawer = !this.drawer;
    });
  }
};
</script>
